import airlineConfig from './config/airline.config.json';

export const globalVariables = {
    // ========================
    // BASIC CONFIGURATION
    // ========================
    COMPANY_NAME: `${airlineConfig.airline.name} - ${airlineConfig.airline.icaoCode}`,
    COOKIE_POLICY_LINK: '/cookie-policy',
    WEBSITE_URL: airlineConfig.contact?.website || '#',
    LAST_UPDATED_DATE: 'April 28, 2025', //Privacy Policy
    LIST_SPECIFIC_PROVIDERS_IF_KNOWN: 'none',
    CONTACT_EMAIL: airlineConfig.contact?.email || 'info@your-va.com',
    SPECIFY_RETENTION_PERIOD: 'two years after account inactivity',
    MINIMUM_AGE: (airlineConfig.airline.minimumAge || 16).toString(),
    DPO_EMAIL: airlineConfig.contact?.dpoEmail || airlineConfig.contact?.email || 'dpo@your-va.com',
    OACI: airlineConfig.airline.icaoCode,

    API_URL: (airlineConfig.urls?.api || 'http://localhost:8000'),

    // ========================
    // PAGE TITLE
    // ========================
    PAGE_TITLE: `${airlineConfig.airline.name} - HiCrew!`,

    // ========================
    // CUSTOMIZABLE TRANSLATIONS
    // ========================
    CUSTOM_TRANSLATIONS: {
        welcome: {
            ES: "Bienvenido a",
            EN: "Welcome to",
            FR: "Bienvenue à",
            PT: "Bem-vindo ao",
            IT: "Benvenuto a",
            CA: "Benvingut a",
            EU: "Ongi etorri",
            GL: "Benvido a"
        },
        title: {
            ES: airlineConfig.airline.name,
            EN: airlineConfig.airline.name,
            FR: airlineConfig.airline.name,
            PT: airlineConfig.airline.name,
            IT: airlineConfig.airline.name,
            CA: airlineConfig.airline.name,
            EU: airlineConfig.airline.name,
            GL: airlineConfig.airline.name
        },
        slogan: airlineConfig.airline.slogan || {},
        info: airlineConfig.airline.description || {}
    }
};